export default "__VITE_ASSET__DuSU0KDI__"